import * as THREE from '../libs/three';
/*
 * show green perpendicular lines when draw custom room or move corner
 */
; (function () {
    'use strict';

    var dependencies = [];

    var service = function () {

        var lineMaterial = new THREE.LineBasicMaterial({
            color: 0x00ff00
        });

        var lineType = {
            HORIZONTAL: 0,
            VERTICAL: 1
        };

        var buildLine = function (type, material) {

            var geometry = new THREE.Geometry();
            geometry.vertices.push(
                new THREE.Vector3(-5000, 0, 0),
                new THREE.Vector3(0, 0, 0),
                new THREE.Vector3(5000, 0, 0)
            );

            var line = new THREE.Line(geometry, material);
            line.visible = false;
            line.name = (type === lineType.HORIZONTAL) ? 'horizontalHelperLine' : 'verticalHelperLine';
            line.rotation.z = (type === lineType.VERTICAL) ? Math.PI / 2 : 0;

            return line;
        };

        var pointIntersection = function (point, points) {
            var pointX,
                pointY,
                i = 0,
                item;

            for (; i < points.length; i++) {
                item = points[i];
                if (Math.abs(item.x - point.x) < 12)
                    pointY = item;
                else if (Math.abs(item.y - point.y) < 12)
                    pointX = item;
            }

            return { x: pointX, y: pointY };
        };

        var horizontal = buildLine(lineType.HORIZONTAL, lineMaterial);
        var vertical = buildLine(lineType.VERTICAL, lineMaterial);

        return {
            test: function (point, points) {

                var intersection = pointIntersection(point, points);
                var result = new THREE.Vector3();

                this.hideAll();

                if (intersection.x && intersection.y) {
                    horizontal.position.set(intersection.x.x, intersection.x.y, 0);
                    vertical.position.set(intersection.y.x, intersection.y.y, 0);
                    horizontal.visible = vertical.visible = true;
                    result.set(intersection.y.x, intersection.x.y, 0);
                }
                else if (intersection.x) {
                    horizontal.position.set(intersection.x.x, intersection.x.y, 0);
                    horizontal.visible = true;
                    result.set(point.x, intersection.x.y, 0);
                }
                else if (intersection.y) {
                    vertical.position.set(intersection.y.x, intersection.y.y, 0);
                    vertical.visible = true;
                    result.set(intersection.y.x, point.y, 0);
                }
                else
                    result = null;

                return result;
            },
            getLines: function () {
                this.hideAll();
                return [horizontal, vertical];
            },
            hideAll: function () {
                vertical.visible = horizontal.visible = false;
            }
        }

    };

    service.$inject = dependencies;

    angular.module('valleyCraftApp').service('helperLines', service);

})();
